export const HTTPS_ASSINATURA_DIGITAL_MESSAGE =
  'É necessário utilizar uma conexão segura com HTTPS para poder utilizar a assinatura digital.'

export const ASSINATURA_DIGITAL_INATIVA_MESSAGE = 'Para habilitar o serviço, a assinatura digital precisa estar ativa.'

export interface ConfiguracaoAssinaturaDigitalModel {
  usuario: string
  senha: string
}

interface ServicoAssinaturaDigitalModel {
  id: string
  habilitado: boolean
}

export interface AssinaturaDigitalModel {
  id: string
  habilitado: boolean
  usuario?: string | null
  senha?: string | null
  documentosEnvioCidadao: ServicoAssinaturaDigitalModel
  assinaturaRegistros?: ServicoAssinaturaDigitalModel | null
  documentosRnds: ServicoAssinaturaDigitalModel
}
